/**
 * Domain Adapter — Survey / Point Cloud (ASPRS LAS 1.4)
 *
 * Phase-2 deliverable. Covers point-cloud and photogrammetry assets in COPC,
 * Potree, or raw LAS/LAZ formats. Not-yet-implemented; returns an explicit
 * typed error.
 *
 * See registry.ts: `layerKind === "copc" | "potree" | "pointcloud"` → "survey".
 */

import type { SceneItem } from "@/sdk-stub/gtwin-sdk/types";
import type { DomainAdapter, DomainAdapterContext, AdapterResult } from "../DomainAdapter";

const SURVEY_LAYER_KINDS = new Set(["copc", "potree", "pointcloud"]);

export const PointCloudAdapter: DomainAdapter = {
  domain: "survey",
  version: "1.0.0",
  standard: "ASPRS-LAS:1.4",

  /**
   * Detects point-cloud / photogrammetry survey assets.
   * Matches `layerKind` in {"copc", "potree", "pointcloud"} or explicit
   * domain extension.
   */
  detect(item: SceneItem): boolean {
    type Extended = SceneItem & { extensions?: { geosoft?: { domain?: string } } };
    const ext = (item as Extended).extensions?.geosoft;
    if (ext?.domain === "survey") return true;
    return SURVEY_LAYER_KINDS.has(item.layerKind);
  },

  async buildManifest(
    _item: SceneItem,
    _asset: { layerId: string; assetNodeId: string; gtwinId: string },
    _context: DomainAdapterContext,
  ): Promise<AdapterResult> {
    return {
      ok: false,
      error: {
        kind: "not-implemented",
        domain: "survey",
        message:
          "Phase 2 deliverable; fall back to synthetic Tier-1 view.",
      },
    };
  },
};
